import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const bonos = [{
  number: 1,
  title: 'Atlas Visual de Porciones y Equivalencias',
  preview: 'https://cdn.magicpatterns.com/uploads/gaY2qop7pXD559bp8KHXkq/Captura_de_pantalla_2026-06-01_082856.png',
  description: 'Una guía visual completa con todas las porciones y equivalencias que necesitás para diseñar planes nutricionales precisos.'
}, {
  number: 2,
  title: 'Sistema de Adherencia Nutricional PRO',
  preview: 'https://cdn.magicpatterns.com/uploads/3SUEPTzw7joVj1c15UeYRW/Captura_de_pantalla_2026-06-01_083220.png',
  subtitle: 'Google Sheets Profesional',
  features: ['Dashboard', 'Seguimiento semanal', 'Semáforos', 'KPIs', 'Evolución', 'Manual de uso']
}, {
  number: 3,
  title: '36 Casos Clínicos Resueltos',
  preview: 'https://cdn.magicpatterns.com/uploads/e3gUc5p9bL4wYA1syn2K5i/Captura_de_pantalla_2026-06-01_083253.png',
  description: 'Una biblioteca de 36 casos clínicos reales resueltos paso a paso para que no te quedes nunca sin recursos.'
}, {
  number: 4,
  title: 'Sistema de Objetivos y Plan de Acción',
  preview: 'https://cdn.magicpatterns.com/uploads/hphsNJSTRZvZtvmqX63Bxf/Captura_de_pantalla_2026-06-01_083334.png',
  features: ['Objetivos SMART', 'Barreras', 'Seguimiento', 'Planificación']
}, {
  number: 5,
  title: 'MegaPack de Formularios Profesionales',
  preview: 'https://cdn.magicpatterns.com/uploads/mpYhWEe2W6m1CBJQnpfxgJ/Captura_de_pantalla_2026-06-01_083437.png',
  features: ['Dashboard del paciente', 'Evaluación inicial', 'Anamnesis', 'Lista de problemas', 'Registro alimentario', 'Registro de síntomas', 'Registro de actividad física', 'Control de medidas', 'Historial de tratamientos', 'Perfil psicoemocional', 'Seguimiento de evolución', 'Cierre de consulta', 'Revisión mensual']
}];
export function Bonos() {
  const [expandedBono, setExpandedBono] = useState<number | null>(null);
  const toggleBono = (number: number) => {
    setExpandedBono(expandedBono === number ? null : number);
  };
  return <section className="w-full py-10 md:py-14 bg-white" data-id="element-38">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-6" data-id="element-40">
          <div className="inline-flex items-center gap-2 bg-amber-500 text-white px-5 py-1.5 rounded-full text-xs font-bold mb-3 animate-pulse" data-id="element-41">
            ⚡ SOLO POR HOY
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-2" data-id="element-42">
            🎁 Bonos exclusivos{' '}
            <span className="text-emerald-600" data-id="element-43">GRATIS por hoy</span>
          </h2>
          <p className="text-sm md:text-base text-slate-600 font-medium" data-id="element-44">
            Estos bonos son GRATIS solo por hoy
          </p>
        </motion.div>

        <div className="space-y-3" data-id="element-45">
          {bonos.map((bono, index) => <motion.div key={bono.number} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className="bg-gradient-to-r from-emerald-50 to-white border-2 border-emerald-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-46">
              {/* Preview image with gradient fade */}
              <div className="relative h-32 sm:h-40 overflow-hidden bg-slate-50" data-id="element-47">
                <img src={bono.preview} alt={`Preview ${bono.title}`} className="w-full h-full object-cover object-top" data-id="element-48" />
                {/* Gradient fade overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/30 to-white pointer-events-none" data-id="element-49" />
              </div>

              <button onClick={() => toggleBono(bono.number)} className="w-full px-4 sm:px-5 py-4 flex items-center justify-between text-left hover:bg-emerald-50 transition-colors duration-200" data-id="element-50">
                <div className="flex items-center gap-3 min-w-0" data-id="element-51">
                  <div className="bg-emerald-600 text-white w-9 h-9 sm:w-10 sm:h-10 rounded-full flex items-center justify-center font-bold flex-shrink-0 text-base sm:text-lg" data-id="element-52">
                    🎁
                  </div>
                  <div className="min-w-0" data-id="element-53">
                    <div className="text-[10px] sm:text-xs font-semibold text-emerald-700" data-id="element-54">
                      BONO {bono.number}
                    </div>
                    <div className="text-sm sm:text-base md:text-lg font-bold text-slate-900 leading-tight" data-id="element-55">
                      {bono.title}
                    </div>
                  </div>
                </div>
                {expandedBono === bono.number ? <ChevronUp className="w-5 h-5 text-emerald-600 flex-shrink-0 ml-2" data-id="element-56" /> : <ChevronDown className="w-5 h-5 text-emerald-600 flex-shrink-0 ml-2" data-id="element-57" />}
              </button>

              <AnimatePresence data-id="element-58">
                {expandedBono === bono.number && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-59">
                    <div className="px-4 sm:px-5 pb-5 pt-1" data-id="element-60">
                      <div className="bg-white rounded-lg p-4 border border-emerald-100" data-id="element-61">
                        {bono.subtitle && <p className="text-sm text-emerald-600 font-semibold mb-2" data-id="element-62">
                            {bono.subtitle}
                          </p>}
                        {bono.description && <p className="text-slate-700 text-sm leading-relaxed mb-3" data-id="element-63">
                            {bono.description}
                          </p>}
                        {bono.features && <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-1.5 text-sm text-slate-700" data-id="element-64">
                            {bono.features.map((feature, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-65">
                                <span className="text-emerald-500 mt-0.5" data-id="element-66">
                                  ✓
                                </span>
                                <span data-id="element-67">{feature}</span>
                              </li>)}
                          </ul>}
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}